import { translate } from '@teamleader/i18n';
import React, { useContext, useMemo } from 'react';

import styles from './styles.css';
import Box from '../../../Components/UI/Box';
import Link from '../../../Components/UI/Link';
import NotFoundIcon from '../../../Svg/120x120_notFound.svg';
import { TYPES } from '../../../Utils/jwt';
import useGlobalContext, { DealContext } from '../Context';

const NotFound: React.FC = () => {
  const { deal } = useContext(DealContext);
  const { type } = useGlobalContext();

  const prefix = useMemo(() => {
    switch (type) {
      case TYPES.DEAL:
        return 'notFound.quotation';
      case TYPES.INVOICE:
        return 'notFound.invoice';
      default:
        return 'notFound';
    }
  }, [type]);

  return (
    <Box className={styles['not-found']}>
      <NotFoundIcon className={styles['not-found-icon']} />
      <h2 className={styles['title']}>{translate(`${prefix}.title`)}</h2>
      <p className={styles['message']}>{translate(`${prefix}.message`)}</p>
      {deal && (
        <p className={styles['contact']}>
          <Link href={`mailto:${deal.responsibleUser?.email || deal.department.email}`}>
            {translate('notFound.contact', { departmentName: deal.department.name })}
          </Link>
        </p>
      )}
    </Box>
  );
};

export default NotFound;
